import { css } from '@emotion/react';
import { Flex } from 'components/box';
import Button from 'components/button';
import { Info as MoreInfoIcon } from 'react-feather';

const MoreInfoButton = ({ callback }: { callback: () => void }) => (
  <Button
    ml={2}
    variant="flat"
    onClick={() => callback()}
    display="inline"
    p={0}
    css={css`
      border: none;
    `}
  >
    <MoreInfoIcon size={18} />
  </Button>
);

const MoreInfo = ({
  label,
  callback,
  justifyContent = 'end',
}: {
  label?: string;
  callback?: () => void;
  justifyContent?: 'start' | 'end';
}) => (
  <Flex
    fontSize={[1, 2, 1]}
    justifyContent={['start', null, justifyContent]}
    alignItems="start"
    lineHeight="1.55em"
    color="darkGrey"
  >
    {label}
    {!!callback && <MoreInfoButton callback={callback} />}
  </Flex>
);

export default MoreInfo;
